export default [
  {
    path: '/home',
    name: 'homepage',
    component: () => import('@/views/home/homepage.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/about-us',
    name: 'about-us',
    component: () => import('@/views/about/aboutUs.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('@/views/contact/contact.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/need-help',
    name: 'help',
    component: () => import('@/views/needhelp/needHelp.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('@/views/error/MissingPermissions.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/pages/authentication/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/company-signup',
    name: 'company-signup',
    component: () => import('@/views/pages/authentication/CompanyRegister.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth'
    },
  },
  {
    path: '/register',
    name: 'auth-register',
    component: () => import('@/views/pages/authentication/Register.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/views/pages/authentication/ForgotPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/pages/authentication/reset-password-v1/:uid/:token/',
    name: 'auth-reset-password-v1',
    component: () => import('@/views/pages/authentication/ResetPassword-v1.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/pages/account-setting',
    name: 'pages-account-setting',
    component: () => import('@/views/pages/account-setting/AccountSetting.vue'),
    meta: {
      pageTitle: 'Account Settings',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Account Settings',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/terms',
    name: 'pages-terms',
    component: () => import('@/views/pages/terms/Terms.vue'),
    meta: {
      pageTitle: 'Support',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Terms & Conditions',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/privacy',
    name: 'pages-privacy',
    component: () => import('@/views/pages/privacy/Privacy.vue'),
    meta: {
      pageTitle: 'Support',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Privacy Policy ',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/cookies',
    name: 'pages-cookies',
    component: () => import('@/views/pages/cookies/Cookies.vue'),
    meta: {
      pageTitle: 'Support',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Cookies Policy',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/faq',
    name: 'pages-faq',
    component: () => import('@/views/pages/faq/Faq.vue'),
    meta: {
      pageTitle: 'Support',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'FAQ',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/release-notes',
    name: 'pages-release-notes',
    component: () => import('@/views/pages/release-notes/release-notes.vue'),
    meta: {
      pageTitle: 'Release Notes',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Release Notes',
          active: true,
        },
      ],
    },
  },
  {
    path: '/company/validate',
    name: 'validate-company-token',
    component: () => import('@/views/pages/authentication/ValidateToken.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth'
    }
  }
]
